import ErrorView from 'scripts/defa/basic/view-error-view';

/**
 * poppet.Controller
 * An extended Marionette Object to use as a basis for other controllers.
 * Note: This poppet class still has hardcoded defa-variables in it. !TODO: Abstract out those vars.
 * @version 0.8.0
 */

const channelLayout = Bb.Radio.channel( 'layout' );
const channel       = Bb.Radio.channel( 'objects' );

const routes = {
	login: '/accounts/login/',
};

const Controller = Mn.Object.extend( {
	
	/**
	 * A function for requesting models before triggering callback functions.
	 * @param {Object} options  An options object to be carried through to the callback function.
	 * @param {Object} modelOptions  An options object only concerned with creating the new Model.
	 * @return {Model} The model requested by ID.
	 */
	requireModel: function ( modelName, modelPath, options ) {
		
		let nameLower  = modelName.charAt( 0 ).toLowerCase() + modelName.slice( 1 ),
			namePlural = nameLower + 's',
			nameId     = nameLower + 'Id';
		
		// Note:
		// Special case for users - because "user" is the logged in user throughout the
		// entire application, we use "currentUser" as the "nameLower" for "user".
		// namePlural and nameId is still kept as "users" and "userId" for concistency.
		
		// !TODO: Deprecate this when the native interface no longer use the channel( 'defa' ).request( 'user' );
		if ( 'User' === modelName ) {
			nameLower = 'currentUser';
		}
		
		// set self and the model-object on options.
		options.self         = options.self || this;
		options[ nameLower ] = channel.request( namePlural ).get( options[ nameId ] );
		options.continue     = options.continue || false;

		// if there is a complete requirement, the model exists, the model can detect completed, and is completed, do
		// the callback
		if ( options.complete && options[ nameLower ] && _.isFunction( options[ nameLower ].isComplete ) && options[ nameLower ].isComplete() ) {
			options.callback( options );
			
			// if there is no complete requirement, and the model exists, do the callback.
		} else if ( !options.complete && options[ nameLower ] ) {
			options.callback( options );
			
			// if not, attach listeners and fetch the model.
		} else {
			if( !options[ nameLower ] ) {
				options[ nameLower ] = new modelPath[ modelName ]( { id: options[ nameId ] } );
			}
			
			options[ nameLower ].fetch({
				success: ()=>{
					// do the callback if the model manages to load
					options[ nameLower ] = channel.request( namePlural ).add( options[ nameLower ] );
					options.callback( options );
				},
				error: function(model, response){
					if(options.continue) {
						options.failed = true;
						options.responseJSON = response.responseJSON;
						options.callback( options );
					} else {
						channelLayout.trigger('error', response.responseJSON);
					}
				}
			});
		}
	},
	
} );

export default Controller;